import { Loading } from 'element-ui';
 
let loadingCount = 0;
let loading;
let title = '加载中...'
 
const startLoading = () => {
  loading = Loading.service({
    lock: true,
    text: title,
    background: 'rgba(0, 0, 0, 0.2)'
  });
};
 
const endLoading = () => {
  loading.close();
};
 
export const showLoading = (newTitle) => {
  newTitle ? title = newTitle : ''
  if (loadingCount === 0) {
    startLoading();
  }
  loadingCount += 1;
};
 
export const hideLoading = () => {
  if (loadingCount <= 0) {
    return;
  }
  loadingCount -= 1;
  if (loadingCount === 0) {
    endLoading();
  }
};